import { Row } from "components/styles";
import Caption from "./Caption/Caption";

const dataCaptions = [
    {
        label: "Remoto",
        color: "var(--light-blue-6)"
    }, 
    {
        label: "Presencial",
        color: "var(--green-3)"
    },
    {
        label: "Turno disponible",
        color: "var(--light-1)",
        borderColor: "var(--purple-8)"
    }, 
    {
        label: "Inactivo",
        color: "var(--gray-1)",
        borderColor: "var(--gray-2)"
    }
];

const CaptionGroup = () => {
    return (
        <Row gap="15px">
            {dataCaptions.map((data, idx) => (
                <Caption key={idx} {...data}/>
            ))}
        </Row>
    );
}

export default CaptionGroup;